import React, { useState, FC } from 'react';
import { NavLink } from 'react-router-dom';
import { MenuItem } from 'ts/types';

interface SubMenuProps {
  title: string;
  initialExpand?: boolean;
  icon: FC<{}>;
  items: MenuItem[];
  setNavClose: () => void;
}

const SubMenu: React.FC<SubMenuProps> = ({ 
  title, icon: Icon, items, setNavClose, initialExpand 
}) => {
  const [expanded, setExpanded] = useState(initialExpand || false);

  const toggleMenu = () => {
    setExpanded(!expanded);
  };

  // Don't render the menu section if there are no items
  if (items.length === 0) {
    return null;
  }

  return (
    <div className="submenu">
      <div
        className={` cursor-pointer pl-2 pr-6 py-2 text-sm font-semibold rounded-lg mx-1.5 
        text-white hover:bg-gray-300 hover:bg-opacity-20`}
        onClick={toggleMenu}
      >
        <div className="flex items-center">
          <Icon />
          <p className="ml-3">{title}</p>
        </div>
      </div>
      <ul
        className={`submenu-list mb-2 transition-all ease-in-out duration-300 ${
          expanded ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        } overflow-hidden`}
      >
        {items.map((item) => (
          <li key={item.routeName} onClick={setNavClose}>
            <NavLink
              to={item.routeName}
              className="flex items-center py-1.5 pl-1 text-center text-sm rounded-lg mx-2 my-0.5 text-white opacity-75 hover:opacity-100 hover:bg-gray-300 hover:bg-opacity-20"
              activeClassName="bg-gray-800 opacity-80 bg-opacity-70 font-semibold"
            >   
              {item.icon}
              <span className="ml-4">{item.title}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SubMenu;